import styled from 'styled-components';
import theme from '../../styles/theme';

const dashedBorderSvg = (color: string) => {
  const c = color.replace('#', '%23');
  return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' preserveAspectRatio='none'%3E%3Crect x='1' y='1' width='98' height='98' rx='10' ry='10' fill='none' stroke='${c}' stroke-width='0.75' stroke-dasharray='6 4' stroke-linecap='square'/%3E%3C/svg%3E")`;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const UploadAreaWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const UploadArea = styled.label<{ hasImage: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  border-radius: 8px;
  cursor: ${({ hasImage }) => (hasImage ? 'default' : 'pointer')};
  transition: all 0.2s ease-in-out;
  background-color: ${theme.colors.neutral.bg.inverted};
  width: 100%;
  min-height: 165px;
  overflow: hidden;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    background-image: ${dashedBorderSvg(theme.colors.primary.bg.regular)};
    background-size: 100% 100%;
    background-repeat: no-repeat;
    pointer-events: none;
  }

  &:hover {
    ${({ hasImage }) =>
      !hasImage &&
      `
      background-color: ${theme.colors.primary.bg.inverted};
      &::before {
        background-image: ${dashedBorderSvg(theme.colors.primary.bg.strong)};
      }
    `}
  }

  input[type='file'] {
    display: none;
  }
`;

export const UploadContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ImagePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  max-height: 200px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
  }
`;

export const InfoText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const ErrorText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
